import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const risks = [
  { id: 1, title: 'Server capacity for launch spike', level: 'High', status: 'Mitigating' },
  { id: 2, title: 'Promo video V3 delay', level: 'Medium', status: 'Monitoring' },
  { id: 3, title: 'App Store review pending', level: 'Low', status: 'Resolved' },
];

const RiskRegister = () => {
  return (
    <div className="glass-panel rounded-xl overflow-hidden">
      <div className="p-4 border-b border-slate-800 bg-slate-900/50 flex justify-between items-center">
        <h3 className="text-sm font-mono text-slate-400 flex items-center">
          <SafeIcon name="AlertOctagon" className="mr-2 text-red-400" />
          RISK RADAR
        </h3>
        <button className="text-xs text-rocket-500 hover:text-rocket-400">View All</button>
      </div>
      <div className="p-2">
        {risks.map(risk => (
          <div key={risk.id} className="p-3 hover:bg-slate-800/50 rounded-lg flex items-center justify-between group transition-colors">
            <div className="flex items-center space-x-3">
              <div className={`w-2 h-2 rounded-full ${
                risk.level === 'High' ? 'bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)]' : 
                risk.level === 'Medium' ? 'bg-yellow-500' : 'bg-green-500'
              }`} />
              <div>
                <p className="text-sm text-ice group-hover:text-white transition-colors truncate max-w-[180px]">{risk.title}</p>
                <p className="text-[10px] font-mono text-slate-500">{risk.status}</p>
              </div>
            </div>
            <SafeIcon name="ChevronRight" className="text-slate-600 group-hover:text-rocket-500" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskRegister;